import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PetPhotoAddPage } from './pet-photo-add.page';
import { ErrorService } from 'src/app/services/error/error.service';

const routes: Routes = [
  {
    path: '',
    component: PetPhotoAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PetPhotoAddPage],
  providers: [
    ErrorService
  ]
})
export class PetPhotoAddPageModule {}
